/**
 * 基础配置
 */
import form from '@/config/form.js'
import router from '@/config/router.js'
import settings from '@/config/settings.js'
export default {
  /** 面料测试 start */
  // 'visitorToken': 'NBGy6GkK0j7YaQQy1mD5tnKyhjR3YoZDkrXrZHV5rlnGqTTtK0xlBOZ/bJUKrMMzDkjnW7pPTlaOLZFTHXpv2tt0V9Q4+zBG0PWhczVGiykEoo6t6aTsq/FVVEsDnfEj8/lzo80KxYaPNqn7kEkK/2DszxmN/FXRgNyHfTM3cLJeZixK8Fn3N7zLiDP6OG4eVeBA89txpr1aMZOcsVhdc3zhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=',
  // 'exhibitionId': '6e140b5e11ca453d8a8ab5bd22a153bb',
  /** 面料测试 end */

  /** 面料正式 start */
  'visitorToken': 'GW1yXNm1dXScd12i7KwdZ+zEAna+am6xpiBNfXBabe7GqTTtK0xlBOZ/bJUKrMMzRBDcfCAP4ykjB93BnvPDt66JloLwAZrgkjd+HkexP5kwT1sHSE+h/Xs6mKebIUL+8/lzo80KxYaPNqn7kEkK/x8+bnM45FlaxrF/nIBJgEQTW70iJmGUYshy/TD1lpQDSyhVk4MgMTS2lZwV3UjQDHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=',
  'exhibitionId': '0d32d96e5fa34ebe8a482c21827be4b9',
  /** 面料正式 end */

  // appId-面料
  'appId': '81cb5253ce3144adbbae3bd8e0fe2f9d',

  /** ZJN测试面料博览会 start */
  // 'visitorToken': 'NBGy6GkK0j7YaQQy1mD5tm/Kc1v+E/P76N7cW02A8t7GqTTtK0xlBOZ/bJUKrMMzDkjnW7pPTlaOLZFTHXpv2tt0V9Q4+zBG0PWhczVGiykEoo6t6aTsq/FVVEsDnfEj8/lzo80KxYaPNqn7kEkK/5Fp8tM1RSIfKivGt5y8qiJTK0mihRbcsnNGAEXyM8Tx4OPLBORXcSObUSWY1pPTLHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=',
  // 'exhibitionId': 'af0e0ee63b7d11eba98e00163e144308',
  // 'appId': '9b6ebcaeb0cb4522ae95222ad55f1220',
  /** 数据合并测试 end */

  // token 名称
  'token': 'Mianliao-Token',
  // 访问基础路径
  'route': '/',
  // 关于我们地址
  'aboutUs': {
    'zh': '',
    'en': ''
  },
  // 帮助手册地址
  'handBook': '',
  'handBook_en': '',
  // 观众版中文帮助手册
  'v_handBook_cn': '',
  // 观众版英文帮助手册
  'v_handBook_en': '',
  // 邀请函地址
  'invitation': '',
  // 首页是否下载app
  'downApp': true,
  // 表单字段
  form: {
    ...form
  },
  // 路由字段
  router: {
    ...router
  },
  chatFetchCount: 20,
  // 开关
  settings: {
    ...settings
  },
}